/**
 * ScaffoldData Normalizr Schema
 */
import { schema as normalizrSchema } from 'normalizr';

import commodity from './commodity';
import descriptionSnippet from './descriptionSnippet';
import entity from './entity';
import entityType from './entityType';
import group from './group';
import groupEntity from './groupEntity';
import groupPerson from './groupPerson';
import person from './person';
import pickType from './pickType';
import role from './role';
import schema from './schema';
import schemaAttribute from './schemaAttribute';
import season from './season';
import variety from './variety';

const scaffoldData = new normalizrSchema.Entity('scaffoldData', {
    commodities: [commodity],
    descriptionSnippets: [descriptionSnippet],
    entities: [entity],
    entityTypes: [entityType],
    groups: [group],
    groupEntities: [groupEntity],
    groupPeople: [groupPerson],
    people: [person],
    pickTypes: [pickType],
    roles: [role],
    schemas: [schema],
    schemaAttributes: [schemaAttribute],
    seasons: [season],
    varieties: [variety]
});

export default scaffoldData;
